<template>
    <div class="vote_card" v-if="vote_visible">
      <div class="contest_image" :style="{backgroundImage: `url(${require(`@/assets/${contest.image}`)})`}"></div>

      <!-- CONTESTANT NAMES WITHOUT CONESTANT IMAGES -->
      <contestant-list-with-out-images
      v-if="!contestant_images"
      :contestants="contestants"
      ></contestant-list-with-out-images>

      <!-- CONTESTANT NAMES WITH CONTESTANT IMAGES -->
      <contestant-list-with-images
      v-if="contestant_images"
      :contestants="contestants"
      :contestant_images="contestant_images"
      ></contestant-list-with-images>

    </div>
</template>

<script>
// import ContestantListWithImages from './vote/ContestantListWithImages.vue';
// import ContestantListWithOutImages from './vote/ContestantListWithOutImages.vue';

export default {
  name: 'VoteCard',
  props: [
    'contest',
    'contestants',
    'vote_visible',
    'contestant_images'
  ],
  data () {
    return {
      
    }
  },
  methods: {
    
  },
  components: {
    // ContestantListWithImages,
    // ContestantListWithOutImages
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.vote_card {
  background: transparent;
  display: block;
  overflow: hidden;

  .contest_image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
}
</style>


// WEBPACK FOOTER //
// src/features/vote/VoteCard.vue